import { render, staticRenderFns } from "./zSwitch.vue?vue&type=template&id=7b2bc999&scoped=true"
import script from "./zSwitch.vue?vue&type=script&lang=js"
export * from "./zSwitch.vue?vue&type=script&lang=js"
import style0 from "./zSwitch.vue?vue&type=style&index=0&id=7b2bc999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2bc999",
  null
  
)

export default component.exports